import { BASE_URL } from "../../../Constant";

export const API_NOTE: string = `${BASE_URL}/api/note`;
export const API_NOTE_LOAD_BY_BUSINESS_ID: string = `${BASE_URL}/api/note/loadByBusinessId`;
